import React from 'react';
import { useQueryClient } from 'react-query';
import { Menu } from 'components/layout/Header/Header/Header';
import { HeaderMenuLink } from 'components/layout/Header/HeaderMenu/HeaderMenuLink';
import { UserInfoWithLzPzus } from 'api';
import { EQueryConst } from 'features/service/config';
import { trackEvent } from 'common/amplitude/amplitude';
import { getEventNameByTabValue } from 'common/utils/amplitude';

interface IProps {
  tab: Menu;
  compact?: boolean;
}

export const HeaderMenuItem: React.FC<IProps> = ({ tab, compact }) => {
  const queryClient = useQueryClient();
  const currentUser = queryClient.getQueryData<UserInfoWithLzPzus>(EQueryConst.CURRENT_USER) as UserInfoWithLzPzus;

  const handleEventClick = (tabName: string) => {
    const eventName = getEventNameByTabValue(tabName) as string;
    const userData = {
      UserId: Number(currentUser.id),
      UserRole: currentUser.roles[0],
    };
    trackEvent(eventName, userData);
  };

  return (
    <li style={{ height: 48 }}>
      <HeaderMenuLink
        key={tab.to}
        isDisabled={false}
        onClick={() => handleEventClick(tab.value)}
        path={tab.to}
        text={compact ? undefined : tab.label}
        Icon={tab.icon}
      />
    </li>
  );
};
